import React from "react";
import GodquantumLanding from "./GodquantumLanding";
import AboutSection from "./AboutSection";
import UseCasesSection from "./UseCasesSection";
import GodquantumLandingPart2 from "./GodquantumLandingPart2";
import QuantumAIBot from "./QuantumAIBot";
import ComprehensiveFooter from "./ComprehensiveFooter";

const CompleteLanding = () => {
  return (
    <>
      <GodquantumLanding />
      <AboutSection />
      <UseCasesSection />
      <GodquantumLandingPart2 />
      <QuantumAIBot />
      <ComprehensiveFooter />
    </>
  );
};

export default CompleteLanding;